import React from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Box } from "@mui/system";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "react-i18next";

const SelectField = ({
  label,
  value,
  onChange,
  menuList,
  defaultValue,
  enableSelection,
  name,
  error,
}) => {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const handleClick = () => {
    if (!enableSelection) {
      setOpen((prev) => !prev);
    }
  };

  const handleClickAway = () => {
    setOpen(false);
  };
  const shouldShowSpouseList = [
    "Spouse List",
    "Mutter / Vater",
    t("relation-mothe"),
    t("relation-father"),
  ].includes(label);

  const getItemText = (item) => {
    if (shouldShowSpouseList) {
      return item?.firstName;
    } else if (item?.translationKey) {
      return t(item.translationKey);
    } else {
      return item.name;
    }
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        component={"div"}
        className={`custom-select ${open ? "focused" : ""}`}
        onClick={() => {
          handleClick();
        }}
      >
        <label className="label">{label}</label>
        <span className="value">{value ? value : defaultValue?.name}</span>
        <ArrowDropDownIcon className="arrow" />
        {open && (
          <ul className="list">
            {menuList.map((item, index) => {
              return (
                <li
                  key={item.name}
                  onClick={() => {
                    onChange(item);
                  }}
                  className={
                    value === item.name ||
                    value === item.firstName ||
                    item.name === defaultValue?.name
                      ? "active"
                      : ""
                  }
                >
                  {getItemText(item)}
                </li>
              );
            })}
          </ul>
        )}
      </Box>
    </ClickAwayListener>
  );
};
export default SelectField;
